import { Box, Grid, Typography } from "@mui/material";
import { DateTime, Info } from "luxon";
import { sift } from "radash";
import formatNumber from "./formatNumber";

export function parseWeekDays(value) {
  return value.length === 7
    ? "All"
    : value
        .map((dayIndex) => Info.weekdays()[dayIndex === 0 ? 6 : dayIndex - 1])
        .map((day) => day.slice(0, 3))
        .join(", ");
}

// https://moment.github.io/luxon/#/formatting
// h -> hour in 12-hour time, no padding
// a -> meridiem (AM/PM)
function convertToAMPM(hour) {
  // unfortunately we have to pad values from 0 to 9 otherwise the .fromISO will not parse the date
  return DateTime.fromISO(hour.toString().padStart(2, "0"))
    .toFormat("h a")
    .toLowerCase();
}

export function parseHourTags(value) {
  return value.map(convertToAMPM).join(" - ");
}

export function isCampaignComplete(endDate) {
  const campaignEnd = DateTime.fromISO(endDate)
    .setZone("America/New_York")
    .toISODate();
  const currentDate = DateTime.now().setZone("America/New_York").toISODate();
  return campaignEnd < currentDate;
}

export const Header = ({ value }) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ alignItems: "center", display: "flex" }}>
        <Typography sx={{ mr: 1 }} variant="h5">
          {value}
        </Typography>
        <Grid item xs={6}>
          &nbsp;
        </Grid>
      </Box>
    </Box>
  );
};

export const CampaignProperty = ({ name, value, xs = 6 }) => {
  return (
    <Grid item xs={xs}>
      <Typography color="text.primary" variant="subtitle2">
        {name}
      </Typography>
      {value === "" && name !== "" ? "-" : value}
    </Grid>
  );
};

const TARGETING_COUNTRIES = {
  us: "United States",
  dz: "Algeria",
  ar: "Argentina",
  au: "Australia",
  at: "Austria",
  bh: "Bahrain",
  be: "Belgium",
  br: "Brazil",
  ca: "Canada",
  cn: "China",
  dk: "Denmark",
  eg: "Egypt",
  fi: "Finland",
  fr: "France",
  de: "Germany",
  gr: "Greece",
  hk: "Hong Kong",
  hu: "Hungary",
  in: "India",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  it: "Italy",
  jp: "Japan",
  jo: "Jordan",
  ke: "Kenya",
  kw: "Kuwait",
  lb: "Lebanon",
  lu: "Luxembourg",
  my: "Malaysia",
  mx: "Mexico",
  ma: "Morocco",
  nl: "Netherlands",
  nz: "New Zealand",
  no: "Norway",
  om: "Oman",
  ps: "Palestine",
  ph: "Philippines",
  pl: "Poland",
  pt: "Portugal",
  pr: "Puerto Rico",
  qa: "Qatar",
  ro: "Romania",
  sa: "Saudi Arabia",
  sg: "Singapore",
  kr: "South Korea",
  es: "Spain",
  se: "Sweden",
  ch: "Switzerland",
  tw: "Taiwan",
  th: "Thailand",
  ae: "United Arab Emirates",
  gb: "United Kingdom",
  ye: "Yemen",
};

export function parseCountryNames(countryCodes) {
  return sift(
    countryCodes
      .split(",")
      .map((countryCode) => TARGETING_COUNTRIES[countryCode])
  ).join(", ");
}

export const formatDate = (value) =>
  value &&
  DateTime.fromISO(value).setZone("America/New_York").toFormat("M/dd/yyyy");

export const formatStartFrom = (value) =>
  typeof value === "string" && value.trim() ? value.trim() : "00:00:00";
export const formatBudget = (value, options = {}) =>
  parseFloat(value, 10)
    ? formatNumber(value, { currency: "USD", style: "currency", ...options })
    : null;
